import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-stakeholders-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-stakeholders-itams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationStakeholdersItamsConstants } from "./create-application-stakeholders-itams.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { RecipientService } from "../../../../shared/components/recipient-components/shared/shared-services/recipient.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
let CreateApplicationStakeholdersItamsComponent = class CreateApplicationStakeholdersItamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    recipientService;
    changeDetectorRefs;
    searchApplicationsService;
    tradersForm;
    disableTraderRecipientFilter = true;
    traderConfigurableLabel = "Trader";
    traderDisableAddButton = false;
    traderRecipientGroups = [];
    traderDisableEditButton = false;
    traderDisableDeleteButton = false;
    tradersFormControlName = CreateApplicationStakeholdersItamsConstants.TRADERS_CONTROL_NAME;
    traderLabel = CreateApplicationStakeholdersItamsConstants.TRADER_LABEL;
    traderFormControlName = CreateApplicationStakeholdersItamsConstants.TRADER_FORM_ARRAY_NAME;
    stepHeader;
    copyApplicantToTraderBtnLabel = CreateApplicationStakeholdersItamsConstants.COPY_APPLICANT_TO_TRADER_BUTTON_LABEL;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, recipientService, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.recipientService = recipientService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.subscribeToSelectedModuleName();
        this.getTraders();
    }
    loadMetadata(stepMeta) {
        this.traderRecipientGroups = stepMeta.traderGroup;
        this.changeDetectorRefs.markForCheck();
    }
    getTradersControl() {
        return this.tradersForm.get(this.tradersFormControlName);
    }
    subscribeToSelectedModuleName() {
        this.applicationCreateService.selectedModuleNameAsObservable.subscribe(() => {
            const header = `${CreateApplicationStakeholdersItamsConstants.STAKEHOLDERS_HEADER}`;
            this.stepHeader = header[0].toUpperCase() + header.substr(1).toLowerCase();
            this.changeDetectorRefs.markForCheck();
        });
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get(CreateApplicationStakeholdersItamsConstants.TRADERS_FORM_GROUP_NAME);
        this.tradersForm = form;
    }
    getTraders() {
        const previousApplicationValidated = this.aflaModuleStrategyService.form.get("detailsForm").get("previousApplicationValidated").value;
        const params = {
            $filter: `(jobId eq ${this.jobId} and moduleId eq ${this.moduleId} and deleted eq false and groups/any(c: c/groupName eq 'Other')) or (jobId eq ${this.jobId} and moduleId eq ${this.moduleId} and deleted eq false and groups/any(c: c/groupName eq 'Trader'))`,
            $expand: `groups`
        };
        if (!previousApplicationValidated) {
            this.recipientService.getRecipientsObservable(params).subscribe({
                next: (recipientArray) => {
                    this.onGetTradersCompleted(recipientArray);
                    this.changeDetectorRefs.detectChanges();
                }, error: err => {
                    this.appController.handleServerErrorMessage("traders", err, CRUDOperation.Get);
                }
            });
        }
        else {
            // application already validated remove recipient list so that user cannot change the selected traders
            this.traderDisableAddButton = true;
            this.traderDisableEditButton = true;
            this.traderDisableDeleteButton = true;
        }
    }
    onGetTradersCompleted(recipientArray) {
        if (recipientArray && recipientArray.length > 0) {
            const tradersControl = this.tradersForm.get(this.tradersFormControlName);
            RecipientUtils.setRecipients(recipientArray, true, tradersControl);
        }
    }
    onBtnCopyApplicantToTraderClicked() {
        const applicantFormValue = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = applicantFormValue;
        const tradersControl = this.getTradersControl();
        const val = tradersControl.value;
        const existingTraders = val ? (Array.isArray(val) ? [...val] : [...(val.recipients || [])]) : [];
        const newTrader = RecipientUtils.makeDeepCopies(applicant, true, true);
        newTrader.setRecipient = true;
        if (this.traderRecipientGroups && this.traderRecipientGroups.length > 0) {
            newTrader.groups = RecipientUtils.standardizeRecipientGroupsObject(this.traderRecipientGroups);
        }
        existingTraders.push(newTrader);
        tradersControl.setValue(existingTraders);
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: RecipientService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationStakeholdersItamsComponent = __decorate([
    Component({
        selector: "app-create-application-stakeholders-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationStakeholdersItamsComponent);
export { CreateApplicationStakeholdersItamsComponent };
